import React, { Component } from 'react';
import Trending from '../Trending/Trending';
import { MODULE_VIEW_EVENT_OPTIONS } from '../Trending/events';

class TrendingCorridorDestinations extends Component {
  componentDidMount() {
    const { fetchTrendingCorridorDestinations, fullURL } = this.props;
    const queryStringStartIndex = fullURL.indexOf('?');
    const queryString = queryStringStartIndex >= 0
      ? fullURL.substring(queryStringStartIndex)
      : '';
    fetchTrendingCorridorDestinations(queryString);
  }

  render() {
    const { showTrendingModal, tiles } = this.props;
    return Array.isArray(tiles) && tiles.length >= 5
      ? <Trending {...{ edapModuleViewEventOptions: MODULE_VIEW_EVENT_OPTIONS, showTrendingModal, tiles }} />
      : null;
  }
}

export default TrendingCorridorDestinations;
